import  '../styles/ProjectCard.css';
import github_logo from '../assets/github.svg'

export default function ProjectCard({ project }) {
  return (
    <div className="card__container">
        <div className='card__header'>
            <h3>{project.name}</h3>
        </div>
        <div className='card__details'>
            <p>{project.description}</p>
        </div>
        <div className='card__urls'>
            <div className='card__github'>
                <img src={github_logo} alt='github_logo'/>
                <a href={project.url} target="_blank" rel="noopener noreferrer">View project</a>
            </div>
        </div>
    </div>
  );
}